const onRE = /^on[^a-z]/;
export const isOn = (key) => onRE.test(key);
export function omitOn(attrs) {
  const result = {};
  for (const key in attrs) {
    if (!isOn(key)) {
      result[key] = attrs[key];
    }
  }
  return result;
}
